// ---------------------------------------------------------------------------
// Data colours (web app v4 page kit): the hues charts, legends and category
// dots use, as CSS colours that follow the theme. Each resolves to a
// `--chart-*` variable in index.css: deeper in light mode so marks hold 3:1
// against the page, the original bright palette in dark.
//
// Pages use these instead of raw hex. Recharts takes them as `fill` and
// `stroke`; style props take them as-is; `dataColour(name, 0.12)` gives a
// tint for a background.
// ---------------------------------------------------------------------------

export const DATA_COLOUR_NAMES = [
  'blue', 'violet', 'lavender', 'coral', 'green', 'amber', 'red', 'cyan', 'lime', 'slate', 'pink',
] as const;

export type DataColourName = typeof DATA_COLOUR_NAMES[number];

/** `hsl(var(--chart-blue))`, or with an alpha for tints. */
export function dataColour(name: DataColourName, alpha?: number): string {
  return alpha === undefined
    ? `hsl(var(--chart-${name}))`
    : `hsl(var(--chart-${name}) / ${alpha})`;
}

/** Status meanings in charts: on plan, at risk, breached; and "not aligned". */
export const STATUS_DATA_COLOUR = {
  success: dataColour('green'),
  warning: dataColour('amber'),
  error: dataColour('red'),
  neutral: dataColour('slate'),
} as const;
